import React from "react";
import bloodVesselImg from "../Images/CatalogueIcon/bloodVessel.png";
import brainImg from "../Images/CatalogueIcon/brain.png";
import colonAnusImg from "../Images/CatalogueIcon/colonAnus.png";
import duodenumImg from "../Images/CatalogueIcon/duodenum.png";
import earImg from "../Images/CatalogueIcon/ear.png";
import esophagusImg from "../Images/CatalogueIcon/esophagus.png";
import eyeballImg from "../Images/CatalogueIcon/eyeball.png";
import gallbladderImg from "../Images/CatalogueIcon/gallbladder.png";
import heartImg from "../Images/CatalogueIcon/heart.png";
import kidneyAdrenalGlandImg from "../Images/CatalogueIcon/kidneyAdrenalGland.png";
import larynxImg from "../Images/CatalogueIcon/larynx.png";
import liverImg from "../Images/CatalogueIcon/liver.png";
import lungImg from "../Images/CatalogueIcon/lung.png";
import lymphaticSystemImg from "../Images/CatalogueIcon/lymphaticSystem.png";
import mammaryGlandImg from "../Images/CatalogueIcon/mammaryGland.png";
import muscleImg from "../Images/CatalogueIcon/muscle.png";
import noseImg from "../Images/CatalogueIcon/nose.png";
import oralCavityImg from "../Images/CatalogueIcon/oralCavity.png";
import pancreasImg from "../Images/CatalogueIcon/pancreas.png";
import peripheralNerveImg from "../Images/CatalogueIcon/peripheralNerve.png";
import pharynxImg from "../Images/CatalogueIcon/pharynx.png";
import prostateImg from "../Images/CatalogueIcon/prostate.png";
import salivaryGlandImg from "../Images/CatalogueIcon/salivaryGland.png";
import skeletalSystemImg from "../Images/CatalogueIcon/skeletalSystem.png";
import skinImg from "../Images/CatalogueIcon/skin.png";
import smallIntestineImg from "../Images/CatalogueIcon/smallIntestine.png";
import spinalCodeImg from "../Images/CatalogueIcon/spinalCord.png";
import spleenImg from "../Images/CatalogueIcon/spleen.png";
import stomachImg from "../Images/CatalogueIcon/stomach.png";
import testisPenisImg from "../Images/CatalogueIcon/testisPenis.png";
import thymusImg from "../Images/CatalogueIcon/thymus.png";
import thyroidParathyroidImg from "../Images/CatalogueIcon/thyroidParathyroid.png";
import tongueImg from "../Images/CatalogueIcon/tongue.png";
import tracheaBronchiImg from "../Images/CatalogueIcon/tracheaBronchi.png";
import ureterImg from "../Images/CatalogueIcon/ureter.png";
import urinaryBladderImg from "../Images/CatalogueIcon/urinaryBladder.png";
import uterusImg from "../Images/CatalogueIcon/uterus.png";

export const activeTools = [
  // Mouse
  {
    name: "Wwwc",
    mode: "active",
    modeOptions: { mouseButtonMask: 1 },
  },
  {
    name: "Zoom",
    mode: "active",
    modeOptions: { mouseButtonMask: 2 },
  },
  {
    name: "Pan",
    mode: "active",
    modeOptions: { mouseButtonMask: 4 },
  },
  "Length",
  "Angle",
  "Bidirectional",
  "RectangleRoi",
  "Eraser",
  // Scroll
  { name: "StackScrollMouseWheel", mode: "active" },
  // Touch
  { name: "PanMultiTouch", mode: "active" },
  { name: "ZoomTouchPinch", mode: "active" },
  { name: "StackScrollMultiTouch", mode: "active" },
];

export const departments = [
  "消化器",
  "循環器",
  "糖尿病･代謝･内分泌",
  "呼吸器",
  "血液",
  "免疫・膠原病",
  "脳･神経",
  "腎･泌尿器",
  "婦人科･乳腺外科",
  "産科",
  "運動器・整形外科",
  "眼科",
  "耳鼻咽喉科",
  "皮膚科",
  "放射線",
  "病理",
];

export const initial = [
  "あ",
  "か",
  "さ",
  "た",
  "な",
  "は",
  "ま",
  "や",
  "ら",
  "わ",
];

export const sex = [
  { display: "男性", value: "1" },
  { display: "女性", value: "2" },
];

export const sites = ["頭頸部", "上肢", "胸部", "腹部", "骨盤部", "下肢"];

export const ages = [
  { display: "~10", value: "0" },
  { display: "10代", value: "10" },
  { display: "20代", value: "20" },
  { display: "30代", value: "30" },
  { display: "40代", value: "40" },
  { display: "50代", value: "50" },
  { display: "60代", value: "60" },
  { display: "70代", value: "70" },
  { display: "80代", value: "80" },
  { display: "90代", value: "90" },
  { display: "100~", value: "100" },
];

export const modals = [
  "CT",
  "MR",
  //'病理',
  //'その他'
];

export const grades = ["1年", "2年", "3年", "4年", "5年", "6年"];

export const prefectures = [
  "北海道",
  "青森県",
  "岩手県",
  "宮城県",
  "秋田県",
  "山形県",
  "福島県",
  "茨城県",
  "栃木県",
  "群馬県",
  "埼玉県",
  "千葉県",
  "東京都",
  "神奈川県",
  "新潟県",
  "富山県",
  "石川県",
  "福井県",
  "山梨県",
  "長野県",
  "岐阜県",
  "静岡県",
  "愛知県",
  "三重県",
  "滋賀県",
  "京都府",
  "大阪府",
  "兵庫県",
  "奈良県",
  "和歌山県",
  "鳥取県",
  "島根県",
  "岡山県",
  "広島県",
  "山口県",
  "徳島県",
  "香川県",
  "愛媛県",
  "高知県",
  "福岡県",
  "佐賀県",
  "長崎県",
  "熊本県",
  "大分県",
  "宮崎県",
  "鹿児島県",
  "沖縄県",
];

export const media = [
  "youtube",
  "twitter",
  "instagram",
  "facebook",
  "MNiSTホームページ",
  "知人からの紹介",
  "いがくせいの森",
  "medteria",
  "その他",
];

export const organs = [
  { name: "皮膚・皮下組織", alt: "skin", src: skinImg },
  { name: "骨格", alt: "skeletal system", src: skeletalSystemImg },
  { name: "筋肉", alt: "muscle", src: muscleImg },
  { name: "脳", alt: "brain", src: brainImg },
  { name: "脊髄", alt: "spinal code", src: spinalCodeImg },
  { name: "末梢神経", alt: "peripheral nerve", src: peripheralNerveImg },
  { name: "眼球", alt: "eyeball", src: eyeballImg },
  { name: "耳", alt: "ear", src: earImg },
  { name: "鼻・副鼻腔", alt: "nose", src: noseImg },
  {
    name: "甲状腺",
    alt: "thyroid and parathyroid",
    src: thyroidParathyroidImg,
  },
  {
    name: "副甲状腺",
    alt: "thyroid and parathyroid",
    src: thyroidParathyroidImg,
  },
  { name: "副腎", alt: "kidney and adrenal gland", src: kidneyAdrenalGlandImg },
  { name: "心臓", alt: "heart", src: heartImg },
  { name: "血管", alt: "blood vessel", src: bloodVesselImg },
  { name: "リンパ", alt: "lymphatic system", src: lymphaticSystemImg },
  { name: "咽頭", alt: "pharynx", src: pharynxImg },
  { name: "喉頭", alt: "arynx", src: larynxImg },
  { name: "乳腺", alt: "mammary gland", src: mammaryGlandImg },
  { name: "胸腺", alt: "thymus", src: thymusImg },
  { name: "気管", alt: "trachea bronchi", src: tracheaBronchiImg },
  { name: "気管支", alt: "trachea bronchi", src: tracheaBronchiImg },
  { name: "肺", alt: "lung", src: lungImg },
  { name: "口腔", alt: "oral cavity", src: oralCavityImg },
  { name: "舌", alt: "tongue", src: tongueImg },
  { name: "唾液腺", alt: "salivary gland", src: salivaryGlandImg },
  { name: "食道", alt: "esophagus", src: esophagusImg },
  { name: "胃", alt: "stomach", src: stomachImg },
  { name: "肝臓", alt: "liver", src: liverImg },
  { name: "胆嚢", alt: "gallbladder", src: gallbladderImg },
  { name: "脾臓", alt: "spleen", src: spleenImg },
  { name: "膵臓", alt: "pancreas", src: pancreasImg },
  { name: "十二指腸", alt: "duodenum", src: duodenumImg },
  { name: "小腸", alt: "small intestine", src: smallIntestineImg },
  { name: "大腸", alt: "colon and anus", src: colonAnusImg },
  { name: "肛門", alt: "colon and anus", src: colonAnusImg },
  { name: "腎臓", alt: "kidney and adrenal gland", src: kidneyAdrenalGlandImg },
  { name: "尿管", alt: "ureter", src: ureterImg },
  { name: "膀胱", alt: "urinary bladder", src: urinaryBladderImg },
  { name: "尿道", alt: "urinary bladder", src: urinaryBladderImg },
  { name: "前立腺", alt: "prostate", src: prostateImg },
  { name: "子宮", alt: "uterus", src: uterusImg },
  { name: "卵巣・卵管", alt: "uterus", src: uterusImg },
  { name: "精巣", alt: "testis and penis", src: testisPenisImg },
  { name: "陰茎", alt: "testis and penis", src: testisPenisImg },
  { name: "腟", alt: "uterus", src: uterusImg },
];

export const universalViewerSetting = {
  updatedAt: "Tue Oct 29 2024 19:49:56 GMT+0900 (日本標準時)",
  toolBoxSetting: {
    tools: [
      "integration3DViewer",
      "menuItemDivider",
      "mousePan",
      "mouseZoom",
      "mouseWindowLevel",
      "menuItemDivider",
      "annotationLastSelected",
      "measurementLastSelected",
      "displaySliceLine",
      "menuItemDivider",
      "groupingAutoGroup",
      "groupingUngroup",
      "groupingClearGroup",
      "groupingSyncOption",
      "groupingSyncReset",
      "menuItemDivider",
      "operationRotation",
      "operationFlip",
      "menuItemDivider",
      "layoutDisplay1",
      "layoutDisplay2",
      "layoutDisplay3",
      "menuItemDivider",
      "layout1x1",
      "layout2x1",
      "layout2x2",
      "layout2x3",
      "layoutFree",
      "menuItemDivider",
      "operationCine",
      "menuItemDivider",
      "operationUndo",
      "operationRedo",
    ],
    subTools: [],
  },
};
